import AspectRatio, { AspectRatioProps } from './AspectRatio';

export default AspectRatio;
export type { AspectRatioProps };
